var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"outline-danger","size":"sm"},on:{"click":_vm.confirmDelete}},[_c('feather-icon',{attrs:{"icon":"Trash2Icon"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }